<template>
  <div class="menu-item">
    <router-link :to="path" @click.native="handleClick" class="menu-link">
      <UserIcon />
      <span>{{ text }}</span>
    </router-link>
    <p class="menu-caption">
      {{ caption }}
    </p>
  </div>
</template>

<script>
import UserIcon from 'assets/images/icons/user-menu.svg?inline'

export default {
  name: 'menu-item',
  components: {
    UserIcon,
  },
  props: {
    path: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    caption: {
      type: String,
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>

<style scoped lang="scss">
.menu-link {
  display: inline-flex;
  align-items: center;
  color: #002560;
  font-size: $header-size-5;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: $margin-xs;
  span {
    margin-left: $margin-xs;
    border-bottom: 2px solid #002560;
  }
}
.menu-caption {
  color: #777e85;
  font-size: 12px;
  max-width: 300px;
}
</style>
